import React, { useEffect, useState } from 'react';

import { useProvincesDealershipsFilter } from '@/hooks/used-cars/provinces-dealerships-filter.hook';

import { MobileFilter } from '../../filters/mobile-filter/mobile-filter';
import { NestedCheckboxes } from '../../nested-checkboxes/nested-checkboxes';

export const Locations: React.FC<{
  handleVisibleChange?: (isVisible: boolean) => void;
  isVisible?: boolean;
}> = ({ handleVisibleChange, isVisible }) => {
  const {
    provincesDealershipsFilter,
    setProvincesDealershipsFilter,
    provincesDealershipsAllSelected,
    toggleProvinceDealership,
  } = useProvincesDealershipsFilter();

  const [locations, setLocations] = useState(provincesDealershipsFilter);

  useEffect(() => {
    if (isVisible) {
      setLocations(provincesDealershipsFilter);
    }
  }, [isVisible]);

  const onClose = () => {
    setProvincesDealershipsFilter(locations);
  };

  return (
    <MobileFilter
      title="Location"
      handleVisibleChange={handleVisibleChange}
      isVisible={isVisible}
      onClose={onClose}
    >
      <NestedCheckboxes
        selectFilter={toggleProvinceDealership}
        options={provincesDealershipsFilter}
        setOptionsState={setProvincesDealershipsFilter}
        resetText="Reset Location"
        selectAllText="All locations"
        hideText="Hide Location"
        allSelected={provincesDealershipsAllSelected}
      />
    </MobileFilter>
  );
};
